/**
 * @file 格式化时间
 */

import fecha from 'fecha'

const formatDate = function (datetime, mask = 'YYYY-MM-DD HH:mm:ss') {
    if (!datetime) {
        return ''
    }
    return fecha.format(datetime, mask)
}

export default formatDate
